import { gql, useQuery } from '@apollo/client';

export const ALLOWED_SUPPORT_REQUEST_CREATION = gql`
  query {
    allowedSupportRequestCreation
  }
`;

export const useCheckIfAllowedSupportRequestCreation = () => {
  const { data, loading } = useQuery(ALLOWED_SUPPORT_REQUEST_CREATION);

  const { allowedSupportRequestCreation = false } = data || {};

  return { loading, allowedSupportRequestCreation };
};
